export { default } from './composeClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/composeClasses/index.js
// module id = 7
// module chunks = 22